'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useCallback } from 'react';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function LogoWithAttachment() {
  const { t } = useTranslations();

  const handleImageClick = useCallback(() => {
    try {
      window.open('/images/unico.pdf', '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Error opening PDF:', error);
    }
  }, []);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-3">
      <p className="text-base font-normal text-[#8E8F92]">{t('text1251')}</p>

      <Image
        onClick={handleImageClick}
        src="/images/eu-logo.jpg"
        alt={t('text1253')}
        width={280}
        height={0}
        className="h-auto w-full max-w-[280px] cursor-pointer object-left"
        sizes="280px"
        priority={false}
      />
    </div>
  );
}
